// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:32
import { TimerItem_abstract } from './../../abstract/SagaBase/Objects/TimerItem_abstract';
export class TimerItem extends TimerItem_abstract {}
